import { useState } from "react";
import { isLeafNode } from "../Utilities/treeUtils";

const TreeNode = ({ node, level = 0 }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="tree-node" style={{ marginLeft: level * 20 + "px" }}>
      {/* Parent Item */}
      <div
        className={`tree-item ${isLeafNode(node) ? "leaf" : "parent"}`}
        onClick={() => !isLeafNode(node) && setExpanded(!expanded)}
      >
        {/* Arrow Icon (Only for non-leaf nodes) */}
        {!isLeafNode(node) && (
          <span className={`tree-icon ${expanded ? "expanded-tree" : ""}`}>
            <i className="fa-solid fa-caret-right"></i>
          </span>
        )}

        {/* Display Item Name Instead of ItemId */}
        <span className="tree-label">{node.itemName}</span>
        {isLeafNode(node) && <span className="leaf-text">(Leaf)</span>}
      </div>

      {/* Child Nodes (Properly Indented Below Parent) */}
      {expanded && !isLeafNode(node) && (
        <div className="tree-children">
          {node.children.map((child, index) => (
            <TreeNode
              key={`${child.itemId}-${index}`}
              node={child}
              level={level + 1}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default TreeNode;
